jQuery(document).ready(function ($) {
	$(".NAVBAR__toggle__wrapper").on("click", function () {
		$(this)
			.parent()
			.siblings(".NAVBAR__links__wrapper")
			.toggleClass("NAVBAR__links__wrapper--open");
	});
});
